import React, { useEffect, useState } from "react";
import { PatternlibTextarea } from "@liebherr/patternlib-react";
import PropTypes from "prop-types";

const FormTextarea = ({
  label,
  placeholder,
  name,
  initialValue,
  onChange,
  error,
  additionalInfo,
}) => {
  const [value, setValue] = useState(initialValue);

  // Call function, when value has been changed
  useEffect(() => {
    if (value) {
      onChange(value);
    } else if (value === "" || value === null) {
      onChange("");
    }
  }, [value]);

  const onChangeListener = (event) => {
    const value = event.detail.value;
    setValue(value);
  };

  return (
    <PatternlibTextarea
      label={label}
      placeholder={placeholder}
      name={name}
      value={initialValue}
      maxlength="255"
      onLhChange={(e) => onChangeListener(e)}
      error-text={error}
      status={error !== null ? "error" : "default"}
      additional-info={additionalInfo}
    ></PatternlibTextarea>
  );
};

FormTextarea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  additionalInfo: PropTypes.string,
};

FormTextarea.defaultProps = {
  label: "Label",
  placeholder: "Placeholder text",
  error: null,
};

export default FormTextarea;
